import React, { Component } from 'react';
import ReactGA from 'react-ga';
import Slider from "react-slick";
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css'; 
//import {Button} from 'primereact/components/button/Button';
const lightBoxStyle = {
  content : {
   // zIndex:21000,
   // backgroundColor: 'red'

    
  }
};
class AiImageBig extends Component {
  constructor(props) {
    super(props);
    this.closeLightBox = this.closeLightBox.bind(this);
    this.slider = React.createRef();
    this.state = {
      photoIndex: this.props.active_view
    };


       // console.log('constructor IMAGE',this.props.active_view)
  }

  componentDidUpdate(){
    this.slider.current.slickGoTo(this.props.active_view)
  }

  closeLightBox () {
    this.props.onCloseOpenBox()
  } 
   
  render() {
   // console.log('render IMAGE view=',this.props.active_view,'of',this.props.max_views,this.props.slides)
    var base_url = this.props.view_image_base;
    //console.log('render IMAGE view=',this.props.view_image_base)
    //base_url =base_url.replace('us.','bridalimages-master.')
    
    let sizeClass=this.props.size
    let slidesRef=this.props.slides
    if (this.state.active_image_url != slidesRef[this.props.active_view]) {
      this.state.active_image_url = slidesRef[this.props.active_view]
      //this.props.onUpdate([this.props.active_view,slidesRef]);
    }

    const settingsPortrait = {
      dots: false,
      //dotsClass: "slick-dots slick-thumb",
      infinite: false,
      className: 'ai-img-wrap-' +sizeClass,
      speed: 500,
      arrows:true,
      fade:true,
      lazyLoad:true,
      slidesToShow: 1,
      centerMode: false,
      slidesToScroll: 1,
      afterChange: (current) => {
        //console.log('ch view',current,this.props.lifeshown,this.props.lifestyle,this.props.max_views);
        if (this.props.lifeshown !== 'yes' && this.props.lifestyle === 'yes')  {
         if (this.props.max_views - 1 === current) {
      //    console.log('ch view done',current);
          this.props.onLife(current); 
        ReactGA.event({
            category: 'lifeshown',
            action:this.props.style
        });}}
        this.props.onChange([current,slidesRef]);}
      
    };
    const settingsLandscape = {
      customPaging: function(i) {
          //let slide = this.props.slides[i]
          /*return (
          <a>
            <img className={'ai-img-thumbnail-'+sizeClass} src={`${base_url}&view=${i+1}`}  alt=''/> 
          </a>*/
          return (
          <a>
            <img className={'ai-img-thumbnail-'+sizeClass} src={`${slidesRef[i]}`}  alt=''/> 
          </a>
        );
      },
      dots: true,
      dotsClass: 'slick-dots slick-dots-'+sizeClass + ' slick-thumb',
      infinite: false,
     // initialSlide: this.props.active_view ,
      speed: 500,
      arrows:false,
      className: 'ai-img-wrap-'+sizeClass,
      fade:true,
      lazyLoad:true,
      slidesToShow: 1,
      centerMode: false,
      //centerPadding: "20px",
      slidesToScroll: 1,
      //afterChange: (current) => {console.log('ch view',current);}
      afterChange: (current) => {
       // console.log('ch view',current);
        //console.log('ch view',current,this.props.lifeshown,this.props.lifestyle,this.props.max_views);
        if (this.props.lifeshown !== 'yes' && this.props.lifestyle === 'yes')  {
          if (this.props.max_views - 1 === current) {
       //    console.log('ch view done',current);
           this.props.onLife(current); 
         ReactGA.event({
             category: 'lifeshown',
             action:this.props.style
         });}}
 
        this.props.onChange([current,slidesRef]);
      }
      
    };
    let settings ={}
   
    if (this.props.orientation === 'portrait') {
      settings =settingsPortrait
     
    }
    else {
      settings =settingsLandscape
    }
   const { photoIndex } = this.state;
   var images=this.props.slides
   var delbuttons =[]
   if (this.props.clistqty >0)
   delbuttons.push(<br key={'br'}/>)
   for (var i=0 ;i<this.props.clistqty;i++)
   {
    //          rows.push(<Toolbar key={cur_option}><Button className="ai-charm100"   value={actionAttrActive} onClick={(e)=>this.props.onAdd(e.currentTarget.value)} label='Add Another Charm'></Button></Toolbar>)
              var marg=  'ai-DelCharm-'+String(this.props.clistqty) 
              //var marg2=  'ai-HideCharm-'+String(this.props.clistqty)
                  
              var keyi ='delkey'+String(i)
    // console.log('delbuttons i',i,marg) 
    if (!this.props.no_show_del)
             delbuttons.push(<img role='button'  key={keyi}  alt='charm' className={marg} width='20' height='20'   value={i} onClick={(e)=>this.props.onDel(e.currentTarget.getAttribute('value'))} src='https://static.thepersonalizedbest.com/pers4/x.jpg'></img>)
     //        delbuttons.push(<img role='button'  key={keyi}  className={marg} width='20' height='20'   value={i} onClick={(e)=>console.log(e.currentTarget.getAttribute('value'))} src='https://static.thepersonalizedbest.com/pers4/x.jpg'></img>)
   //          delbuttons.push(<a role='button'  key={keyi}  className={marg} value={i} onClick={(e)=>this.props.onDel(e.currentTarget.value)}><img  width='20' height='20'   src='https://static.thepersonalizedbest.com/pers4/x.jpg'></img></a>)
           }
 //  if (this.props.hidelast)        
 //               delbuttons.push(<div  key="lasthide"  className={marg2} ></div>)
   
  // console.log('delbuttons',delbuttons) 
   return (
      <div className='ai-image-big-wrap'  >
      {delbuttons}
        <Slider ref={this.slider}   {...settings} >
        {this.props.slides.map(slide =>
              // <div className={'ai-img-'+sizeClass}  key={slide}  >
            
                <img className={'ai-src-img-'+sizeClass}  
                key={slide}
                src={slide} 
                onClick={this.props.onOpenOpenBox}
                alt=''   />
              
              // </div>
          
            
          )}
      
      </Slider>  
     
      {( this.props.pushOpenBox ) && (
           <Lightbox
            mainSrc={images[photoIndex] + '&m=1200'}
            nextSrc={images[(photoIndex + 1) % images.length]+ '&m=1200'}
            prevSrc={images[(photoIndex + images.length - 1) % images.length]+ '&m=1200'}
            onCloseRequest={this.closeLightBox}
            reactModalStyle={lightBoxStyle}
            onMovePrevRequest={() =>
              this.setState({
                photoIndex: (photoIndex + images.length - 1) % images.length,
              })
            }
            enableZoom ={false}
            onMoveNextRequest={() =>
              this.setState({
                photoIndex: (photoIndex + 1) % images.length,
              })
            }  
             onAfterOpen={() =>
               this.setState({
                 photoIndex: this.props.active_view,
               })
             }  
          />
          )
        
      }

        </div>
    );
  }
}
export default AiImageBig;


// WEBPACK FOOTER //
// ./src/layout/AiImageBig.js